<template>
  <template v-for="(item, index) in data">
    <!-- 因为有子集和无子集渲染html标签不一样，所以要分为两种情况情况一：有子集的情况：-->
    <el-sub-menu
      :key="item.permission"
      :index=item.permissionId.toString()
      v-if="item.userPermissionChildren.length > 0 && item.userPermissionChildren.find(itemIndex => itemIndex.permissionType === 1)"
    >
      <template #title>
        <el-icon><svg-icon :iconClass="item.icon" width="15"></svg-icon></el-icon>
        <span>{{ item.permissionName }}</span>
      </template>
      <myMenu :data="item.userPermissionChildren"></myMenu>
    </el-sub-menu>
    <!-- 情况二：没子集的情况： -->
    <el-menu-item v-else :index=item.permissionId.toString() v-if="item.permissionType === 1">
      <el-icon><svg-icon :iconClass="item.icon" width="15"></svg-icon></el-icon>
      <span>{{ item.permissionName }}</span>
    </el-menu-item>
  </template>
</template>
<script>
//注册图标组件
import navIcon from "@/components/icon/navIcon";

export default {
  components: {
    navIcon,
  },
  name: "myMenu",
  props: ["data"],
  mounted() {
  },
};
</script>

<style scoped>
</style>
